import React, { useMemo } from 'react';
import '../styles/Environment.css';
import { translations } from '../translations';

const Environment = ({ language }) => {
  const t = translations[language];
  
  const initiatives = useMemo(() => [
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="m17 14 3 3.3a1 1 0 0 1-.7 1.7H4.7a1 1 0 0 1-.7-1.7L7 14h-.3a1 1 0 0 1-.7-1.7L9 9h-.2A1 1 0 0 1 8 7.3L12 3l4 4.3a1 1 0 0 1-.8 1.7H15l3 3.3a1 1 0 0 1-.7 1.7H17Z"></path>
          <path d="M12 22v-3"></path>
        </svg>
      ),
      title: typeof t.environment.initiatives.greenBuffers === 'object' ? t.environment.initiatives.greenBuffers.heading : t.environment.initiatives.greenBuffers,
      description: typeof t.environment.initiatives.greenBuffers === 'object' ? t.environment.initiatives.greenBuffers.content : t.environment.initiatives.greenBuffersDesc,
      readMoreContent: typeof t.environment.initiatives.greenBuffers === 'object' ? t.environment.initiatives.greenBuffers.readMoreContent : null
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-6.5c-.5 2.5-2 4.9-4 6.5C6 11.1 5 13 5 15a7 7 0 0 0 7 7z"></path>
        </svg>
      ),
      title: typeof t.environment.initiatives.lakeRejuvenation === 'object' ? t.environment.initiatives.lakeRejuvenation.heading : t.environment.initiatives.lakeRejuvenation,
      description: typeof t.environment.initiatives.lakeRejuvenation === 'object' ? t.environment.initiatives.lakeRejuvenation.content : t.environment.initiatives.lakeRejuvenationDesc,
      readMoreContent: typeof t.environment.initiatives.lakeRejuvenation === 'object' ? t.environment.initiatives.lakeRejuvenation.readMoreContent : null
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M14 13h2a2 2 0 0 1 2 2v2a2 2 0 0 0 4 0v-6.998a2 2 0 0 0-.59-1.42L18 5"></path>
          <path d="M14 21V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v16"></path>
          <path d="M2 21h13"></path>
          <path d="M3 9h11"></path>
        </svg>
      ),
      title: typeof t.environment.initiatives.serviceAreas === 'object' ? t.environment.initiatives.serviceAreas.heading : t.environment.initiatives.serviceAreas,
      description: typeof t.environment.initiatives.serviceAreas === 'object' ? t.environment.initiatives.serviceAreas.content : t.environment.initiatives.serviceAreasDesc,
      readMoreContent: typeof t.environment.initiatives.serviceAreas === 'object' ? t.environment.initiatives.serviceAreas.readMoreContent : null
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M8 6v6"></path>
          <path d="M15 6v6"></path>
          <path d="M2 12h19.6"></path>
          <path d="M18 18h3s.5-1.7.8-2.8c.1-.4.2-.8.2-1.2 0-.4-.1-.8-.2-1.2l-1.4-5C20.1 6.8 19.1 6 18 6H4a2 2 0 0 0-2 2v10h3"></path>
          <circle cx="7" cy="18" r="2"></circle>
          <path d="M9 18h5"></path>
          <circle cx="16" cy="18" r="2"></circle>
        </svg>
      ),
      title: typeof t.environment.initiatives.publicTransport === 'object' ? t.environment.initiatives.publicTransport.heading : t.environment.initiatives.publicTransport,
      description: typeof t.environment.initiatives.publicTransport === 'object' ? t.environment.initiatives.publicTransport.content : t.environment.initiatives.publicTransportDesc,
      readMoreContent: typeof t.environment.initiatives.publicTransport === 'object' ? t.environment.initiatives.publicTransport.readMoreContent : null
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="4"></circle>
          <path d="M12 2v2"></path>
          <path d="M12 20v2"></path>
          <path d="m4.93 4.93 1.41 1.41"></path>
          <path d="m17.66 17.66 1.41 1.41"></path>
          <path d="M2 12h2"></path>
          <path d="M20 12h2"></path>
          <path d="m6.34 17.66-1.41 1.41"></path>
          <path d="m19.07 4.93-1.41 1.41"></path>
        </svg>
      ),
      title: typeof t.environment.initiatives.sustainableLighting === 'object' ? t.environment.initiatives.sustainableLighting.heading : t.environment.initiatives.sustainableLighting,
      description: typeof t.environment.initiatives.sustainableLighting === 'object' ? t.environment.initiatives.sustainableLighting.content : t.environment.initiatives.sustainableLightingDesc,
      readMoreContent: typeof t.environment.initiatives.sustainableLighting === 'object' ? t.environment.initiatives.sustainableLighting.readMoreContent : null
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
          <circle cx="12" cy="10" r="3"></circle>
        </svg>
      ),
      title: typeof t.environment.initiatives.waterfront === 'object' ? t.environment.initiatives.waterfront.heading : t.environment.initiatives.waterfront,
      description: typeof t.environment.initiatives.waterfront === 'object' ? t.environment.initiatives.waterfront.content : t.environment.initiatives.waterfrontDesc,
      readMoreContent: typeof t.environment.initiatives.waterfront === 'object' ? t.environment.initiatives.waterfront.readMoreContent : null
    }
  ], [t.environment.initiatives]);

  return (
    <section id="environment" className="environment-section">
      <div className="container">
        <div className="environment-content">
          <div className="section-header">
            <h2 className="section-title">{t.environment.title}</h2>
            <h3 className="section-subtitle">{t.environment.subtitle}</h3>
            <p className="section-description environment-section-lead">
              {t.environment.description} {t.environment.descriptionReadMore}
            </p>
          </div>
          <div className="environment-grid">
            {initiatives.map((initiative, index) => (
              <div key={index} className="environment-card">
                <div className="environment-icon">{initiative.icon}</div>
                <h4 className="environment-title">{initiative.title}</h4>
                {(initiative.description || initiative.readMoreContent) && (
                  <p className="environment-description">
                    {initiative.description}
                    {initiative.readMoreContent && (
                      <span className="environment-description-more">{initiative.readMoreContent}</span>
                    )}
                  </p>
                )}
              </div>
            ))}
          </div>
          {t.environment.lakeSustainability && typeof t.environment.lakeSustainability === 'object' && (
            <div className="lake-sustainability-card">
              <h4 className="card-title">{t.environment.lakeSustainability.heading}</h4>
              <div className="lake-content">
                <p className="card-text">
                  {t.environment.lakeSustainability.content}
                  {t.environment.lakeSustainability.readMoreContent && (
                    <span className="environment-lake-more">{t.environment.lakeSustainability.readMoreContent}</span>
                  )}
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Environment;
